import React from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Panel } from 'components/ui/index';
import { Button, Icon } from 'antd';
import { Permission } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';
import Enums from 'utils/EnumsManager';
import IpListsTable from './IpListsTable';

const { PhantomId } = Enums;

const IpLists = ({
  intl,
}) => {
  const { formatMessage } = intl;

  const rightAction = (
    <Permission permission={PERMISSIONS.SETUP_SYSTEMS_IPWHITELIST_ADD}>
      <Link to={`/setup/systems/ip-setting?id=${PhantomId}`}>
        <Button className="btn-ellipse ml-sm" size="small">
          <Icon type="plus" />
          {formatMessage({ id: 'global.ui.button.add' })}
        </Button>
      </Link>
    </Permission>
  );

  return (
    <Panel
      panelTitle={formatMessage({ id: 'page.IpWhiteLists.ipWhiteLists' })}
      actionsRight={rightAction}
      contentClasses="pt-lg pb-lg pl-lg pr-lg"
    >
      <IpListsTable />
    </Panel>
  );
};


export default injectIntl(IpLists);



// WEBPACK FOOTER //
// ./src/views/Setup/IpWhiteLists/component/IpLists.jsx